import { useEffect, useMemo, useState } from "react"
import { useLocation, Link } from 'react-router-dom'
import { Input, Button, Table, Select, DatePicker, Space } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosNoInfo } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import { SelectStores } from "../../component/common/Selects"
import getPermission from '../../js/permission'
import moment from "moment"
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

type fetchParams = {
    store_id: string | undefined,
    check_in_user_name: string | undefined,
    check_in_phone: number | undefined,
    preg_status: number | undefined,
    expect_born_month: any,
    actually_born_month: any,
    room_number: number | undefined
    check_in_status: number | undefined,
    checkInDay: any,
    checkOutDay: any,
    belong_dietician_id: string | undefined,
    tomorrow_food_plan_status: number | undefined,
}

interface ep {
    "employee_id": string,
    "user_name": string
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        check_in_user_name: undefined,
        check_in_phone: undefined,
        preg_status: undefined,
        expect_born_month: undefined,
        actually_born_month: undefined,
        room_number: undefined,
        check_in_status: undefined,
        checkInDay: null,
        checkOutDay: null,
        belong_dietician_id: undefined,
        tomorrow_food_plan_status: undefined
    }

    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    // 获取链接参数
    const Location: any = useLocation()

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(() => {
        // 回填链接传回的数值
        let stateFetchOtherParams = null

        if (Location.state && Location.state.fetchOtherParams) {
            const { fetchOtherParams } = Location.state

            if (fetchOtherParams.checkInDay) {
                fetchOtherParams.checkInDay[0] = moment(fetchOtherParams.checkInDay[0])
                fetchOtherParams.checkInDay[1] = moment(fetchOtherParams.checkInDay[1])
            }

            if (fetchOtherParams.checkOutDay) {
                fetchOtherParams.checkOutDay[0] = moment(fetchOtherParams.checkOutDay[0])
                fetchOtherParams.checkOutDay[1] = moment(fetchOtherParams.checkOutDay[1])
            }

            stateFetchOtherParams = fetchOtherParams

        } else {
            stateFetchOtherParams = fetchOtherParamsTmpl
        }

        return stateFetchOtherParams
    })

    const [loading, setLoading] = useState<boolean>(false)
    const [data, setData] = useState<any>([])

    const [yys, setYys] = useState<any[]>([])

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        baseAxiosNoInfo('/global/employee_list_by_position', {
            params: {
                position_number: 36
            }
        }).then((res: any) => {
            res && setYys(res)
        })
    }, [])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        handleDate(params, 'checkInDay', ['check_in_start_day', 'check_in_end_day'])
        handleDate(params, 'checkOutDay', ['check_out_start_day', 'check_out_end_day'])

        axiosTable.get('/cooking_center/customer/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    function handleDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

            delete param[attr]
        }
    }

    return (<div className="common-page">
        {/* 膳食中心 -> 营养膳食 -> 入住客户管理 */}
        <BreadCrumb position={['膳食中心', '入住客户管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores value={fetchOtherParams.store_id} onChange={(v: string) => {
                        baseAxiosNoInfo('/global/employee_list_by_position', {
                            params: {
                                department_id: v,
                                position_number: 36
                            }
                        }).then((res: any) => {
                            res && setYys(res)
                        })

                        let s = _.cloneDeep(fetchOtherParams)
                        s.store_id = v

                        setFetchOtherParams(s)
                    }} />
                </div>

                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="入住人名称" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_user_name') }} value={fetchOtherParams.check_in_user_name} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="入住人手机号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_phone') }} value={fetchOtherParams.check_in_phone} />

                <Select allowClear className="fl" virtual={false} style={{ marginRight: 12, marginBottom: 12, width: 150 }} placeholder="怀孕状态" value={fetchOtherParams.preg_status} onChange={(v: number) => { handleChange(v, 'preg_status') }}>
                    <Option value={1} key={1}>正在备孕</Option>
                    <Option value={2} key={2}>已经怀孕</Option>
                    <Option value={3} key={3}>已有宝宝</Option>
                    <Option value={4} key={4}>小月子</Option>
                    <Option value={5} key={5}>孕早期</Option>
                    <Option value={6} key={6}>孕中期</Option>
                    <Option value={7} key={7}>孕晚期</Option>
                    <Option value={8} key={8}>预产期前7天</Option>
                    <Option value={9} key={9}>已分娩</Option>
                    <Option value={10} key={10}>超出预产期</Option>
                    <Option value={0} key={0}>未知</Option>
                </Select>

                <DatePicker allowClear className="fl" style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="预产期" onChange={(v: any) => {
                    let s = _.cloneDeep(fetchOtherParams)

                    if (v) {
                        s.expect_born_month = moment(v).format('YYYY-MM')
                    } else {
                        s.expect_born_month = null
                    }

                    setFetchOtherParams(s)
                }} picker="month" value={fetchOtherParams.expect_born_month ? moment(fetchOtherParams.expect_born_month) : null} />

                <DatePicker allowClear className="fl" style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="分娩日" onChange={(v: any) => {
                    let s = _.cloneDeep(fetchOtherParams)

                    if (v) {
                        s.actually_born_month = moment(v).format('YYYY-MM')
                    } else {
                        s.actually_born_month = null
                    }

                    setFetchOtherParams(s)
                }} picker="month" value={fetchOtherParams.actually_born_month ? moment(fetchOtherParams.actually_born_month) : null} />

                <Select allowClear className="fl" virtual={false} style={{ marginRight: 12, marginBottom: 12, width: 120 }} placeholder="入住状态" value={fetchOtherParams.check_in_status} onChange={(v: number) => { handleChange(v, 'check_in_status') }}>
                    <Option value={1} key={1}>已预订</Option>
                    <Option value={2} key={2}>已入住</Option>
                    <Option value={3} key={3}>已出所</Option>
                </Select>
                <Input className="fl" style={{ marginRight: 12, marginBottom: 12, width: 120 }} placeholder="房号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'room_number') }} value={fetchOtherParams.room_number} />
                <RangePicker className="fl" style={{ marginRight: 12, marginBottom: 12, width: 250 }} placeholder={["入住开始日期", "入住结束日期"]} value={fetchOtherParams.checkInDay} onChange={(v: any) => { handleChange(v, 'checkInDay') }} />
                <RangePicker className="fl" style={{ marginRight: 12, marginBottom: 12, width: 250 }} placeholder={["出所开始日期", "出所结束日期"]} value={fetchOtherParams.checkOutDay} onChange={(v: any) => { handleChange(v, 'checkOutDay') }} />

                <Select allowClear className="fl" virtual={false} style={{ marginRight: 12, marginBottom: 12, width: 120 }} placeholder="明日排餐" value={fetchOtherParams.tomorrow_food_plan_status} onChange={(v: number) => { handleChange(v, 'tomorrow_food_plan_status') }}>
                    <Option value={0} key={0}>未排餐</Option>
                    <Option value={1} key={1}>已保存</Option>
                    <Option value={2} key={2}>已下单</Option>
                </Select>
                <Select allowClear className="fl" virtual={false} style={{ marginRight: 12, marginBottom: 12, width: 120 }} placeholder="营养师" value={fetchOtherParams.belong_dietician_id} onChange={(v: string) => { handleChange(v, 'belong_dietician_id') }}>
                    {yys.map((el: any) => <Option value={el.employee_id} key={el.employee_id}>{el.user_name}</Option>)}
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch} >查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column fixed title="操作" render={(row: any) => {
                    return permission.includes("查看") ? <Link to={'/cooking_customer_detail/' + row.id} >查看详情</Link> : null
                }} />

                <Column fixed title="客户姓名" dataIndex="check_in_user_name" key="check_in_user_name" />
                <Column fixed title="客户手机号" dataIndex="check_in_phone" key="check_in_phone" />
                <Column title="怀孕时期" dataIndex="preg_status_desc" key="preg_status_desc" />
                <Column title="预产期" dataIndex="expect_born_day" key="expect_born_day" />
                <Column title="分娩日" dataIndex="actually_born_day" key="actually_born_day" />

                <Column title="签单套餐" dataIndex="deal_item_name" key="deal_item_name" />
                <Column title="明日排餐状态" dataIndex="tomorrow_food_plan_status" key="tomorrow_food_plan_status" render={(v: number) => {
                    switch (v) {
                        case 0:
                            return '未排餐'
                        case 1:
                            return '已保存'
                        case 2:
                            return '已下单'
                    }
                }} />

                <Column title="入住门店" dataIndex="check_in_store_name" key="check_in_store_name" />
                <Column title="预住天数" dataIndex="check_in_total_days" key="check_in_total_days" />
                <Column title="已住天数" dataIndex="check_in_already_days" key="check_in_already_days" />
                <Column title="剩余天数" dataIndex="check_in_left_days" key="check_in_left_days" />
                <Column title="入住状态" dataIndex="check_in_status_desc" key="check_in_status_desc" />
                <Column title="入住时间" dataIndex="check_in_time" key="check_in_time" />
                <Column title="出所日期" dataIndex="check_out_time" key="check_out_time" />
                <Column title="入住信息" dataIndex="room_number" key="room_number" />

                <Column title="高价菜品已用次数" dataIndex="high_price_menu_item_times" key="high_price_menu_item_times" />
                <Column title="营养师" dataIndex="belong_dietician_name" key="belong_dietician_name" />
            </Table>
        </div>
    </div>)
}